export var SessionType;
(function (SessionType) {
    SessionType["CONTINUOUS"] = "CONTINUOUS";
    /**
     * @deprecated Use MANUAL instead
     */
    SessionType["PLAIN"] = "MANUAL";
    /**
     * @description Manually triggered session recording
     */
    SessionType["MANUAL"] = "MANUAL";
    /**
     * @description Just for corellation without cache
     */
    SessionType["SESSION"] = "SESSION";
    /**
     * @description Correlation + caching
     */
    SessionType["SESSION_CACHE"] = "SESSION_CACHE";
})(SessionType || (SessionType = {}));
//# sourceMappingURL=session-type.enum.js.map